import React, { FC } from 'react';
import { Button as MaterialButton, CircularProgress } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

interface IProps {
  text?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset' | undefined;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  color?: string;
  textColor?: string;
}

const Button: FC<IProps & ButtonProps> = ({
  text,
  onClick = () => {},
  type = undefined,
  fullWidth = false,
  disabled = false,
  loading = false,
  color = undefined,
  textColor = undefined,
  ...rest
}) => {
  return (
    <MaterialButton
      variant="contained"
      onClick={onClick}
      type={type}
      fullWidth={fullWidth}
      disabled={disabled}
      style={{
        background: color ?? undefined,
        color: textColor ?? undefined,
      }}
      {...rest}
    >
      {text}

      {loading && <CircularProgress style={{ width: '20px', height: '20px', margin: '0 5px' }} />}
    </MaterialButton>
  );
};

export default Button;
